import _ from 'lodash';
import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { getCollectionOrder } from '../Collection/Helpers';
import {
  CLEAR_CHANNEL_PANELS,
  FETCH_CHANNEL,
  SET_CHANNEL,
  UPDATE_VISIBLE_ELEMENTS,
} from './Actions';

const INITIAL_STATE = {
  channelData: null,
  panels: null,
  seo: null,
  headline: null,
  headlineLogo: '',
  errors: null,
  visibleCollections: {},
  showcase: null,
  channelOrder: [],
  forceKeyartForShowcase: false,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  const seo = _.get(action, 'payload.panels.seo', null);
  switch (action.type) {
    case CLEAR_CHANNEL_PANELS: {
      return {
        ...state,
        channelData: null,
        channelOrder: [],
        headlineLogo: '',
        panels: null,
        seo: null,
        showcase: null,
      };
    }

    case FETCH_CHANNEL: {
      if (errors) return { ...state, errors };
      return state;
    }

    case SET_CHANNEL: {
      const payload = action?.payload;
      const { channelData } = payload;
      const panels = payload?.panels;
      const showcase = payload?.showcase;
      const headline = payload?.headline;
      const headlineLogo = payload?.headlineLogo;

      return {
        ...state,
        channelData,
        channelOrder: getCollectionOrder(panels),
        forceKeyartForShowcase: false,
        headline,
        headlineLogo,
        panels,
        seo,
        showcase,
      };
    }
    case UPDATE_VISIBLE_ELEMENTS: {
      return {
        ...state,
        visibleCollections: action.payload,
      };
    }
    default:
      return state;
  }
}
